/* global script_l10n, woocommerce_params */
$.fn.CurrentPlan = function () {
  let self = this;
  self.prompt = $('.prompt-box');
  self.prompt.el = {
    title: self.prompt.find('.prompt-box__title'),
    description: self.prompt.find('.prompt-box__description'),
    cancel: self.prompt.find('.btn.btn-secondary'),
    confirm: self.prompt.find('.btn.btn-primary')
  };

  self.open = function () {
    $.fancybox.open({
      src: '.prompt-box',
      type: 'inline',
      touch: false,
      clickOutside: false,
      clickSlide: false,
      smallBtn: false,
      toolbar: false
    });
  };

  self.suspend = function (e) {
    e.preventDefault();
    self.prompt.el.title.html(script_l10n.ON_HOLD_TITLE);
    self.prompt.el.description.html(script_l10n.ON_HOLD_MESSAGE);
    self.prompt.el.cancel.text(script_l10n.ON_HOLD_CANCEL).off('click');
    self.prompt.el.confirm.text(script_l10n.ON_HOLD_CONFIRM).attr('href', $(this).attr('href')).off('click');
    self.open();
  };

  self.cancel = function (e) {
    e.preventDefault();
    self.prompt.el.title.html(script_l10n.CANCEL_TITLE);
    self.prompt.el.description.html(script_l10n.CANCEL_MESSAGE);
    self.prompt.el.cancel.text(script_l10n.CANCEL_CANCEL).off('click');
    self.prompt.el.confirm.text(script_l10n.CANCEL_CONFIRM).attr('href', $(this).attr('href')).off('click');
    self.open();
  };

  self.update_product = function (subscription_id, item_id, item_name, incrementField, quantity, previous_quantity) {
    self.prompt.el.title.html(script_l10n.UPDATE_ITEM_TITLE);
    let difference = quantity - previous_quantity,
      message = difference > 0 ? script_l10n.UPDATE_PLUS_ITEMS_MESSAGE : script_l10n.UPDATE_MINUS_ITEMS_MESSAGE;
    message = message.replace('%s', item_name);
    message = message.replace('%d', Math.abs(difference));
    self.prompt.el.description.html(message);
    self.prompt.el.cancel
      .text(script_l10n.CANCEL)
      .off('click')
      .on('click', function () {
        incrementField.val(previous_quantity);
      });
    self.prompt.el.confirm
      .text(script_l10n.CONFIRM)
      .attr('href', $(this).attr('href'))
      .off('click')
      .on('click', function () {
        $.fancybox.close();
        $('.dashboard-plan').block({
          message: null,
          overlayCSS: {
            'background-color': '#ffffff'
          }
        });
        $.post(
          woocommerce_params.ajax_url,
          {
            action: 'update_subscription_product',
            subscription_id: subscription_id,
            item_id: item_id,
            quantity: quantity
          },
          function (x) {
            if (x.success) {
              $('.current-plan__amount').html(x.total);
              incrementField.closest('li').find('input[name="previous_quantity"]').val(quantity);
            } else {
              incrementField.val(previous_quantity);
            }
            $('.dashboard-plan').unblock();
          },
          'json'
        );
      });
    self.open();
  };

  self.remove_product = function (subscription_id, item_id, item_name, incrementField, previous_quantity, is_cancel) {
    if (is_cancel) {
      self.prompt.el.title.html(script_l10n.CANCEL_TITLE);
      self.prompt.el.description.html(script_l10n.REMOVE_CANCEL_MESSAGE.replace('%s', item_name));
    } else {
      self.prompt.el.title.html(script_l10n.UPDATE_ITEM_TITLE);
      self.prompt.el.description.html(script_l10n.REMOVE_ITEM_MESSAGE.replace('%s', item_name));
    }
    self.prompt.el.cancel
      .text(script_l10n.CANCEL)
      .off('click')
      .on('click', function () {
        incrementField.val(previous_quantity);
      });
    self.prompt.el.confirm
      .text(script_l10n.CONFIRM)
      .attr('href', $(this).attr('href'))
      .off('click')
      .on('click', function () {
        $.fancybox.close();
        $('.dashboard-plan').block({
          message: null,
          overlayCSS: {
            'background-color': '#ffffff'
          }
        });
        $.post(
          woocommerce_params.ajax_url,
          {
            action: 'remove_subscription_product',
            subscription_id: subscription_id,
            item_id: item_id
          },
          function (x) {
            if (x.success) {
              if (x.reload_page) {
                location.reload();
              } else {
                $('.current-plan__amount').html(x.total);
                $('li[data-item-id="' + x.removed_item + '"]').remove();
                $('.current-plan__image[data-item-id="' + x.removed_item + '"]').remove();
              }
            } else {
              incrementField.val(previous_quantity);
            }
            $('.dashboard-plan').unblock();
          },
          'json'
        );
      });
    self.open();
  };

  return (function () {
    self.find('.current-plan__link--suspend').on('click', self.suspend);
    self.find('.current-plan__link--cancel').on('click', self.cancel);

    /* Increment fields */
    self.find('.qty').each(function () {
      const incrementField = $(this).IncrementField();
      incrementField.on('change', function () {
        let item = $(this).closest('li'),
          previous_quantity = parseInt(item.find('input[name="previous_quantity"]').val(), 10),
          quantity = parseInt(incrementField.val(), 10);
        if (quantity) {
          self.update_product(
            item.data('subscription-id'),
            item.data('item-id'),
            item.find('.current-plan__item').text(),
            incrementField,
            quantity,
            previous_quantity
          );
        } else {
          self.remove_product(
            item.data('subscription-id'),
            item.data('item-id'),
            item.find('.current-plan__item').text(),
            incrementField,
            previous_quantity,
            self.find('.current-plan__desc li').length < 2
          );
        }
      });
    });
    return self;
  })();
};

export default {
  init() {
    /* Manage current plan */
    $('.current-plan').each(function () {
      $(this).CurrentPlan();
    });

    /* Add product to subscription */
    $('.add-to-subscription').on('click', function () {
      /* Prompt box */
      self.prompt = $('.prompt-box');
      self.prompt.el = {
        title: self.prompt.find('.prompt-box__title'),
        description: self.prompt.find('.prompt-box__description'),
        cancel: self.prompt.find('.btn.btn-secondary'),
        confirm: self.prompt.find('.btn.btn-primary')
      };

      self.prompt.el.title.html(script_l10n.UPDATE_ITEM_TITLE);
      let quantity = parseInt($('.summary.entry-summary input.qty').val(), 10);
      if (quantity >= 1) {
        let message = script_l10n.UPDATE_PLUS_ITEMS_MESSAGE;
        message = message.replace('%d', quantity);
        message = message.replace('%s', $('h1.product_title.entry-title').text());
        self.prompt.el.description.html(message);
        self.prompt.el.cancel
          .text(script_l10n.CANCEL)
          .off('click')
          .on('click', function () {
            $.fancybox.close();
          });
        self.prompt.el.confirm
          .text(script_l10n.CONFIRM)
          .attr('href', $(this).attr('href'))
          .off('click')
          .on('click', function () {
            $.fancybox.close();
            $('.product-content').block({
              message: null,
              overlayCSS: {
                'background-color': $('.content-area').css('background-color')
              }
            });
            let product_id = $('.single_add_to_cart_button[name="add-to-cart"]').val();
            $.post(
              woocommerce_params.ajax_url,
              {
                action: 'add_subscription_product',
                product_id: product_id,
                quantity: quantity
              },
              function (x) {
                $('.product-content').unblock();
                if (x.success) {
                  let notification = $('<div>').addClass('woocommerce-message d-flex').attr('role', 'alert').html(x.message);
                  $('.woocommerce-notices-wrapper').empty().append(notification);
                }
              },
              'json'
            );
          });
        $.fancybox.open({
          src: '.prompt-box',
          type: 'inline',
          touch: false,
          clickOutside: false,
          clickSlide: false,
          smallBtn: false,
          toolbar: false
        });
      }
    });
  }
};
